import ActionRow from "../components/v2/ActionRow";
import ChoiceStack from "../components/v2/ChoiceStack";
import HelperLine from "../components/v2/HelperLine";
import PageTransition from "../components/v2/PageTransition";
import QuestionCounter from "../components/v2/QuestionCounter";
import QuestionLabel from "../components/v2/QuestionLabel";
import Wordmark from "../components/v2/Wordmark";
import "../components/v2/v2-question-surface.css";

export const SURFACE_7_LABEL = "How do you know them?";
export const SURFACE_7_HELPER = "Pick the closest fit.";

export const RELATIONSHIP_OPTIONS = [
  {
    key: "partner_spouse",
    title: "Partner / spouse",
    explanation: "the person you share a life with",
  },
  {
    key: "family",
    title: "Family",
    explanation: "parent, child, or sibling",
  },
  {
    key: "family_extended",
    title: "Family — extended",
    explanation: "aunt, uncle, cousin, in-laws",
  },
  {
    key: "best_friend",
    title: "Best friend",
    explanation: "the person they'd call first",
  },
  {
    key: "close_friend",
    title: "Close friend",
    explanation: "someone you see often, know well",
  },
  {
    key: "friend",
    title: "Friend",
    explanation: "in your life, but not in the inner ring",
  },
  {
    key: "coworker",
    title: "Coworker / colleague",
    explanation: "someone you know through work",
  },
  {
    key: "mentor_mentee",
    title: "Mentor / mentee",
    explanation: "you've taught each other things",
  },
  {
    key: "other",
    title: "Other",
    explanation: "someone who doesn't fit the rest",
  },
];

export default function Surface7({
  value,
  direction = "forward",
  onChange,
  onBack,
  onNext,
  editMode = false,
}) {
  return (
    <section className="tgc-v2-surface tgc-v2-surface--choice" aria-labelledby="question-label">
      <PageTransition direction={direction}>
        <div className="tgc-v2-choice-shell">
          <div className="tgc-v2-choice-header">
            <Wordmark variant="stacked" />
            <QuestionCounter current={3} total={12} />
            <QuestionLabel>{SURFACE_7_LABEL}</QuestionLabel>
            <HelperLine id="surface-7-helper">{SURFACE_7_HELPER}</HelperLine>
          </div>

          <div className="tgc-v2-choice-scroll" aria-describedby="surface-7-helper">
            <ChoiceStack
              options={RELATIONSHIP_OPTIONS}
              value={value}
              behavior="single-select"
              autoAdvance={!editMode}
              ariaLabel="Relationship options"
              onChange={onChange}
              onAutoAdvance={onNext}
            />
          </div>

          <div className="tgc-v2-choice-back">
            <ActionRow
              variant={editMode ? "done-only" : "back-only"}
              onBack={onBack}
              onNext={onNext}
              nextDisabled={!value}
              nextLabel="Done"
            />
          </div>
        </div>
      </PageTransition>
    </section>
  );
}
